function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M0,3.22C0-.62,4.323-.756,6.476,1.395l13.042,11.56a4.094,4.094,0,0,1,0,5.788L6.476,30.3C4.152,32.625,0,32.849,0,28.482V3.22Z",
  transform: "translate(32.039) rotate(90)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M7.927,1.537,20.972,13.1a4.117,4.117,0,0,1,0,5.788L7.927,30.444C3.213,35.161-2.8,29.237,1.441,24.984c2.921-2.914,6.2-6.1,6.2-6.1a4.106,4.106,0,0,0,0-5.788L1.441,7c-4.3-4.3,2.258-9.691,6.486-5.46Z",
  transform: "translate(32.182 15.759) rotate(90)",
  fill: "#fff"
});

var SvgBizdocsDown = function SvgBizdocsDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    width: 32.182,
    height: 37.92,
    viewBox: "0 0 32.182 37.92",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBizdocsDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bizdocs_down.00c010c1.svg";
export { ForwardRef as ReactComponent };